import { useFormik } from "formik";
import React, { useContext, useEffect, useRef, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { BASE_URL, CDN_BASE_URL } from "../../../config";
import Loading from "../Loading";
import ReactQuill from "react-quill";
import { httpReauest } from "../../../utils/httpRequest";
import { Editor } from "@tinymce/tinymce-react";
import CustomModal from "../Modal";
import { CiHeart } from "react-icons/ci";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import UploadedModal from "../UploadedModal";
import { AuthContext } from "../../../context/AuthContext";

const CreateBlogForm = () => {
  const [img, setImg] = useState();
  const [show, setshow] = useState();
  const [img2, setImg2] = useState();
  const [previewImg, setPreviewImg] = useState();
  const [previewImg2, setPreviewImg2] = useState();
  const [loading, setloading] = useState();
  const [categorys, setCategorys] = useState();
  const [seoScore, setSeoScore] = useState();
  const [drafts, setdrafts] = useState();
  const [file, setfile] = useState();
  const [text, settext] = useState();
  const [timing, settiming] = useState();
  const [blogCategory, setblogCategory] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    await httpReauest("GET", "/blog/draft", {}, {}).then(({ data }) => {
      setdrafts(data?.data);
    });

    await httpReauest("GET", "/blogcategory", {}, {}).then(({ data }) => {
      setblogCategory(data?.data);
    });
  }

  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      name: Yup.string().required("الزامی است"),
      url: Yup.string().required("الزامی است"),
      category: Yup.string().required("الزامی است"),
    });
  };
  const { user, setUser } = useContext(AuthContext);

  const analyzeSeoFromBackend = async () => {
    const body = {
      content: editorRef.current?.getContent({ format: "text" }) || "",
      title: formik.values.name,
      description: formik.values.meta_desc,
      keyword: formik.values.meta_keywords,
      url: formik.values.url,
    };

    try {
      const res = await fetch(BASE_URL + "/blog/seo-analyze", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (res.ok) {
        setSeoScore(data.data);
        toast.success("تحلیل سئو انجام شد");
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error("خطا در اتصال به سرور سئو");
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      meta_keywords: "",
      meta_desc: "",
      content: "",
      author: "",
      desc: "",
      url: "",
      category: "",
      draft: false,
      date: "",
      _id: false,
    },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      setloading(true);
      const formdata = new FormData();
      formdata.append("name", values.name);
      formdata.append("author", values.author);
      formdata.append("meta_keywords", values.meta_keywords);
      formdata.append("meta_desc", values.meta_desc);
      formdata.append("content", editorRef.current?.getContent());
      formdata.append("desc", values.desc);
      formdata.append("url", values.url);
      formdata.append("category", values.category);
      if (values.draft) {
        formdata.append("draft", values.draft);
      }

      if (values._id) {
        formdata.append("_id", values._id);
      }
      if (timing) {
        formdata.append("date", values.date);
      }
      if (img2) {
        formdata.append("cover", img2, img2?.name);
      }

      await fetch(BASE_URL + "/blog", {
        method: "POST",
        body: formdata,
        headers: { "x-access-token": user.token },
      })
        .then(async (dat) => {
          if (dat?.status == 201) {
            toast.success("بلاگ ساخته شد");
            setloading(false);
            formik.resetForm();
            setImg(null);
            setImg2(null);
            setPreviewImg(null);
            setPreviewImg2(null);
          } else {
            const message = await dat.json();
            setloading(false);
            toast.error(message.message);
          }
        })
        .catch((err) => {
          setloading(false);
          toast.error(err.response?.data?.message);
        });
    },
  });

  function handleImg(e) {
    const fils = e.target.files[0];
    if (fils.size > 2031517) {
      toast.error("حجم فایل باید کمتر از دو مگابایت باشد");
    } else {
      setImg(fils);
      setPreviwImage(fils);
    }
  }
  function handleImg2(e) {
    const fils = e.target.files[0];
    if (fils.size > 2031517) {
      toast.error("حجم فایل باید کمتر از دو مگابایت باشد");
    } else {
      setImg2(fils);
      setPreviwImage2(fils);
    }
  }

  async function setPreviwImage(imgInput) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setPreviewImg(reader.result);
    };
    reader.readAsDataURL(imgInput);
  }

  async function setPreviwImage2(imgInput) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setPreviewImg2(reader.result);
    };
    reader.readAsDataURL(imgInput);
  }

  const editorRef = useRef(null);

  async function handleUpload() {
    if (!file) {
      return toast.error("فایلی انتخاب نشده است");
    }

    const formdata = new FormData();
    formdata.append("file", file, file.name);

    const res = await fetch(BASE_URL + "/blog/upload", {
      method: "POST",
      body: formdata,
      headers: { "x-access-token": user.token },
    });

    const data = await res.json();

    settext(data.data);
    setfile(null);
  }

  return (
    <div>
      <h2 className="text-[20px] mb-8 font-bold p-3">فرم ایجاد بلاگ</h2>

      <form
        onSubmit={formik.handleSubmit}
        className="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-6"
      >
        <span className="relative">
          <input
            placeholder="مثلا : دانتستی ها درباره فوتون 450"
            id="name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.name && formik.touched.name && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.name}
            </small>
          )}
          <p className="on-border font-bold">نام بلاگ*</p>
        </span>

        <span className="relative">
          <input
            id="author"
            name="author"
            value={formik.values.author}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.author && formik.touched.author && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.author}
            </small>
          )}
          <p className="on-border font-bold">نام نویسنده*</p>
        </span>
        <span className="relative">
          <input
            id="url"
            name="url"
            value={formik.values.url}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.url && formik.touched.url && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.url}
            </small>
          )}
          <p className="on-border font-bold">url*</p>
        </span>
        <span className="relative">
          <select
            id="category"
            name="category"
            value={formik.values.category}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          >
            <option></option>
            {blogCategory?.map((e) => (
              <option value={e._id}>{e.name}</option>
            ))}
          </select>
          {formik.errors.category && formik.touched.category && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.category}
            </small>
          )}
          <p className="on-border font-bold">دسته بندی بلاگ</p>
        </span>
        <span className="relative">
          <input
            placeholder="مثلا : کامیون , کشنده , فوتون 450"
            id="meta_keywords"
            name="meta_keywords"
            value={formik.values.meta_keywords}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          <p className="on-border font-bold">کلمات کلیدی*</p>
          {formik.errors.meta_keywords && formik.touched.meta_keywords && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.meta_keywords}
            </small>
          )}
        </span>

        <span className="relative col-span-full">
          <textarea
            placeholder="مثلا : دانتستی ها درباره فوتون 450"
            id="meta_desc"
            name="meta_desc"
            value={formik.values.meta_desc}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[88px]"
          />
          {formik.errors.meta_desc && formik.touched.meta_desc && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.meta_desc}
            </small>
          )}
          <p className="on-border font-bold">توضیح متا*</p>
        </span>
        <span className="relative col-span-full">
          <textarea
            placeholder="مثلا : دانتستی ها درباره فوتون 450"
            id="desc"
            name="desc"
            value={formik.values.desc}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[88px]"
          />
          {formik.errors.desc && formik.touched.desc && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.desc}
            </small>
          )}
          <p className="on-border font-bold">مقدمه</p>
        </span>
        <input
          onChange={(e) => {
            handleImg2(e);
          }}
          type="file"
          className="hidden"
          id="img2"
          accept="image/png, image/jpg, image/jpeg"
        />
        <label
          htmlFor="img2"
          className="relative w-full border-dashed border rounded-[10px] p-3 h-[200px] cursor-pointer border-[#444] col-span-full"
        >
          {previewImg2 ? (
            <img
              src={previewImg2}
              className="w-full h-full object-contain"
              alt=""
            />
          ) : (
            <FaPlus className="center" size={30} />
          )}

          <p className="on-border font-bold">کاور</p>
        </label>
        <input
          onChange={(e) => {
            handleImg(e);
          }}
          type="file"
          className="hidden"
          id="img"
          accept="image/png, image/jpg, image/jpeg"
        />
        <span className="col-span-full">
          <h5 className="text-[24px] font-bold">آپلود:</h5>
          <input
            onChange={(e) => {
              setfile(e.target.files[0]);
            }}
            type="file"
            className="my-2"
            id="fileUpload"
            accept="image/*, video/*"
          />
          {text && <div className="mb-2"> آدرس : {CDN_BASE_URL + text}</div>}

          <button type="button" onClick={handleUpload} className="btn-brand">
            آپلود
          </button>
          <UploadedModal />
        </span>
        <span className="col-span-full">
          <h1 className="title text-right">محتوا:</h1>
          <p className="mb-3">
            برای آپلود تصویر یا ویدیو از کامپیوتر روی بخش آپلود بالای سر کلیک
            کنید و فایل را اپلود کنید بعد از ان به شما لینک فایل را میدهد تا
            بتوانید در محتوا استفاده کنید
          </p>
          <Editor
            apiKey="92g70vdbmsvq2gbo0n8n77e4r2wb4c4l1aj84cq2enrfrixw"
            onInit={(evt, editor) => (editorRef.current = editor)}
            initialValue={formik.values.content}
            init={{
              plugins:
                "anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount  linkchecker code",
              toolbar:
                "undo redo | blocks fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat",
              tinycomments_mode: "embedded",
              tinycomments_author: "Author name",
              mergetags_list: [
                { value: "First.Name", title: "First Name" },
                { value: "Email", title: "Email" },
              ],
              ai_request: (request, respondWith) =>
                respondWith.string(() =>
                  Promise.reject("See docs to implement AI Assistant")
                ),
            }}
          />
        </span>
        <span className="col-span-full">
          <button
            type="button"
            onClick={analyzeSeoFromBackend}
            className="btn-brand bg-green-600 hover:bg-green-700"
          >
            تحلیل سئو
          </button>

          {seoScore && (
            <div className="mt-6 space-y-4 text-gray-700 p-4 bg-orange-200">
              {/* امتیاز کلی سئو */}
              <div className="flex items-center gap-4">
                <div
                  className={`w-[24px] h-[24px] rounded-full ${
                    seoScore.seoScore >= 75
                      ? "bg-green-500"
                      : seoScore.seoScore >= 50
                      ? "bg-yellow-400"
                      : "bg-red-500"
                  }`}
                  title={`امتیاز کلی سئو: ${seoScore.seoScore}`}
                ></div>
                <p className="font-semibold">
                  امتیاز کلی سئو: {seoScore.seoScore} از ۱۰۰
                </p>
              </div>

              {/* نمره خوانایی */}
              <div className="flex items-center gap-2">
                <span className="font-medium w-48">نمره خوانایی (Flesch):</span>
                <span>{seoScore.readabilityScore} از ۱۰۰</span>
              </div>

              {/* تعداد کلمات */}
              <div className="flex items-center gap-2">
                <span className="font-medium w-48">تعداد کلمات:</span>
                <span>{seoScore.wordCount} کلمه</span>
              </div>

              {/* تعداد جملات */}
              <div className="flex items-center gap-2">
                <span className="font-medium w-48">تعداد جملات:</span>
                <span>{seoScore.sentenceCount} جمله</span>
              </div>

              {/* میانگین تعداد کلمات در هر جمله */}
              <div className="flex items-center gap-2">
                <span className="font-medium w-48">
                  میانگین کلمات در هر جمله:
                </span>
                <span>{seoScore.avgWordsPerSentence.toFixed(1)}</span>
              </div>
            </div>
          )}
        </span>
        {timing && (
          <span>
            <label>انتخاب زمان برای انتشار : </label>
            <DatePicker
              format="MM/DD/YYYY HH:mm:ss"
              onChange={(e) => {
                formik.setFieldValue("date", new Date(e));
              }}
              calendar={persian}
              locale={persian_fa}
              plugins={[<TimePicker position="bottom" />]}
              calendarPosition="bottom-right"
              className="form-brand w-full"
              style={{ height: "45px" }}
            />
          </span>
        )}
        <span className="col-span-full">
          {loading ? (
            <Loading />
          ) : (
            <span className="flex gap-3 flex-wrap">
              <button className="btn-brand">ارسال</button>
            </span>
          )}
        </span>
      </form>
    </div>
  );
};

export default CreateBlogForm;
